import { useEffect } from 'react'
import { useRouter } from 'arcway/lib/client'

import { useSession } from './use-session.js'

export function useGuestSession(next = '/account') {
  const router = useRouter()
  const session = useSession()

  useEffect(() => {
    if (session.authenticated) {
      router.next(next, { replace: true })
    }
  }, [next, router, session.authenticated])

  return session
}
